import { mergeStyles } from "@fluentui/react";
import { getPlannerIconName } from "./getPlannerIcon";
import { css } from "@fluentui/utilities/lib/css";
export const iconClassname = mergeStyles({
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
/**
 * Returns the icon props for the given icon name
 */ const makeIconProps = (iconName)=>({
        iconName: getPlannerIconName(iconName),
        className: css("plannerIcon", iconName, iconClassname)
    });
export const addAgentIconProps = makeIconProps("plannerAddAgent");
export const addPublishTemplateIconProps = makeIconProps("plannerPublishTemplate");
export const addIconProps = makeIconProps("plannerAdd");
export const addSmallIconProps = makeIconProps("plannerAddSmall");
export const appsListIconProps = makeIconProps("plannerAppsList");
export const assignIconProps = makeIconProps("plannerAssign");
export const assignTeamIconProps = makeIconProps("plannerAssignTeam");
export const barChartIconProps = makeIconProps("plannerBarChart");
export const blockedIconProps = makeIconProps("plannerBlocked");
export const boardSplitFilledIconProps = makeIconProps("plannerBoardSplitFilled");
export const boardSplitRegularIconProps = makeIconProps("plannerBoardSplitRegular");
export const calendarIconProps = makeIconProps("plannerCalendar");
export const calendarIconFilledProps = makeIconProps("plannerCalendarFilled");
export const calendarPersonIconProps = makeIconProps("plannerCalendarPerson");
export const plannerCalendarAddIconProps = makeIconProps("plannerCalendarAdd");
export const checkMarkIconProps = makeIconProps("plannerCheckMark");
export const chatRegularIconProps = makeIconProps("plannerChatRegular");
export const chevronDownIconProps = makeIconProps("plannerChevronDown");
export const chevronDownSmallIconProps = makeIconProps("plannerChevronDownSmall");
export const chevronLeftIconProps = makeIconProps("plannerChevronLeft");
export const chevronLeftExtraSmallIcon = makeIconProps("plannerChevronLeftExtraSmall");
export const chevronLeftLargeIconProps = makeIconProps("plannerChevronLeftLarge");
export const chevronRightIconProps = makeIconProps("plannerChevronRight");
export const chevronRightSmallIconProps = makeIconProps("plannerChevronRightSmall");
export const chevronRightExtraSmallIcon = makeIconProps("plannerChevronRightExtraSmall");
export const chevronRightLargeIconProps = makeIconProps("plannerChevronRightLarge");
export const chevronUpIconProps = makeIconProps("plannerChevronUp");
export const completedIconProps = makeIconProps("plannerCompleted");
export const commentMultipleIconProps = makeIconProps("plannerCommentMultiple");
export const copyIconProps = makeIconProps("plannerCopy");
export const deleteIconProps = makeIconProps("plannerDelete");
export const deleteSmallIconProps = makeIconProps("plannerDeleteSmall");
export const diamondIconProps = makeIconProps("plannerDiamond");
export const dismissIconProps = makeIconProps("plannerDismiss");
export const dismissSmallIconProps = makeIconProps("plannerDismissSmall");
export const dismissExtraSmallIconProps = makeIconProps("plannerDismissExtraSmall");
export const dismissCircleIconProps = makeIconProps("plannerDismissCircle");
export const dismissCircleFilledIconProps = makeIconProps("plannerDismissCircleFilled");
export const dividerIconProps = makeIconProps("plannerDivider");
export const dotIconProps = makeIconProps("plannerDot");
export const downIconProps = makeIconProps("plannerDown");
export const downSmallIconProps = makeIconProps("plannerDownSmall");
export const expandIconProps = makeIconProps("plannerExpand");
export const editIconProps = makeIconProps("plannerEdit");
export const errorIconProps = makeIconProps("plannerError");
export const eyeHideIconProps = makeIconProps("plannerEyeHide");
export const eyeOffIconProps = makeIconProps("plannerEyeOff");
export const favoriteStarFilledIconProps = makeIconProps("plannerFavoriteStarFilled");
export const favoriteStarIconProps = makeIconProps("plannerFavoriteStar");
export const filterIconProps = makeIconProps("plannerFilter");
export const ganttIconProps = makeIconProps("plannerGantt");
export const goalsIconProps = makeIconProps("plannerGoals");
export const goalsIconFilledProps = makeIconProps("plannerGoalsFilled");
export const groupIconProps = makeIconProps("plannerGroup");
export const homeIconProps = makeIconProps("plannerHome");
export const imageIconProps = makeIconProps("plannerImage");
export const infoIconLargeProps = makeIconProps("plannerInfoLarge");
export const infoIconProps = makeIconProps("plannerInfo");
export const infoSmallIconProps = makeIconProps("plannerInfoSmall");
export const leftIconProps = makeIconProps("plannerLeft");
export const linkIconProps = makeIconProps("plannerLink");
export const linkDismissIconProps = makeIconProps("plannerLinkDismiss");
export const lockIconProps = makeIconProps("plannerLock");
export const moreIconProps = makeIconProps("plannerMore");
export const moreIconFilledProps = makeIconProps("plannerMoreFilled");
export const moreVerticalIconProps = makeIconProps("plannerMoreVertical");
export const moveIconProps = makeIconProps("plannerMove");
export const myDayFilledIconProps = makeIconProps("plannerMyDayFilled");
export const myDayRegularIconProps = makeIconProps("plannerMyDayRegular");
export const myDayRegularSmallIconProps = makeIconProps("plannerMyDayRegularSmall");
export const myPlansFilledIconProps = makeIconProps("plannerMyPlansFilled");
export const myPlansRegularIconProps = makeIconProps("plannerMyPlansRegular");
export const myTasksFilledIconProps = makeIconProps("plannerMyTasksFilled");
export const myTasksRegularIconProps = makeIconProps("plannerMyTasksRegular");
export const navigationIconProps = makeIconProps("plannerNavigation");
export const openInNewWindowIconProps = makeIconProps("plannerOpenInNewWindow");
export const panelLeftContractProps = makeIconProps("plannerPanelLeftContract");
export const panelRightContractProps = makeIconProps("plannerPanelRightContract");
export const pdfIconProps = makeIconProps("plannerPdf");
export const peopleIconProps = makeIconProps("plannerPeople");
export const peopleLargeIconProps = makeIconProps("plannerPeopleLarge");
export const personArrowLeftIconProps = makeIconProps("plannerPersonArrowLeft");
export const personIconProps = makeIconProps("plannerPerson");
export const personFeedbackIconProps = makeIconProps("plannerPersonFeedback");
export const phoneIconProps = makeIconProps("plannerPhone");
export const pinFilledIconProps = makeIconProps("plannerPinFilled");
export const pinIconProps = makeIconProps("plannerPin");
export const pinOffFilledIconProps = makeIconProps("plannerPinOffFilled");
export const pinOffIconProps = makeIconProps("plannerPinOff");
export const plugConnectedIconProps = makeIconProps("plannerPlugConnected");
export const planHubIconProps = makeIconProps("plannerPlanHub");
export const questionIconProps = makeIconProps("plannerQuestion");
export const questionCircleIconProps = makeIconProps("plannerQuestionCircle");
export const recentsIconProps = makeIconProps("plannerRecents");
export const recurrenceIconProps = makeIconProps("plannerRecurrence");
export const recurrenceSmallIconProps = makeIconProps("plannerRecurrenceSmall");
export const reOrderDotsVerticalIconProps = makeIconProps("plannerReOrderDotsVertical");
export const retryIconProps = makeIconProps("plannerRetry");
export const revToggleIconProps = makeIconProps("plannerRevToggle");
export const sortLinesIconProps = makeIconProps("plannerSortLines");
export const groupListIconProps = makeIconProps("plannerGroupList");
export const searchIconProps = makeIconProps("plannerSearch");
export const sendIconProps = makeIconProps("plannerSend");
export const sendFilledIconProps = makeIconProps("plannerSendFilled");
export const stopSmallIconProps = makeIconProps("plannerStopSmall");
export const tagIconProps = makeIconProps("plannerTag");
export const taskListIconProps = makeIconProps("plannerTaskList");
export const taskListFilledIconProps = makeIconProps("plannerTaskListFilled");
export const taskboardIconProps = makeIconProps("plannerTaskboard");
export const taskboardIconFilledProps = makeIconProps("plannerTaskboardFilled");
export const unknownIconProps = makeIconProps("plannerUnknown");
export const uploadIconProps = makeIconProps("plannerUpload");
export const upSmallIconProps = makeIconProps("plannerUpSmall");
export const approvalsAppFilledIconProps = makeIconProps("plannerApprovalsAppFilled");
export const squareDismissIconProps = makeIconProps("plannerSquareDismiss");
export const gridIconProps = makeIconProps("plannerTable");
export const gridIconFilledProps = makeIconProps("plannerTableFilled");
export const chartIconProps = makeIconProps("plannerChart");
export const chartIconFilledProps = makeIconProps("plannerChartFilled");
export const dependenciesIconProps = makeIconProps("plannerColumnArrowRightIcon");
export const editPersonIconProps = makeIconProps("plannerEditPerson");
export const attachIconProps = makeIconProps("plannerAttach");
// Progress Icons
export const progressNotStartedIconProps = makeIconProps("plannerProgressNotStarted");
export const progressNotStartedSmallIconProps = makeIconProps("plannerProgressNotStartedSmall");
export const progressInProgressIconProps = makeIconProps("plannerProgressInProgress");
export const progressInProgressSmallIconProps = makeIconProps("plannerProgressInProgressSmall");
export const progressCompleteIconProps = makeIconProps("plannerProgressComplete");
export const progressCompleteSmallIconProps = makeIconProps("plannerProgressCompleteSmall");
// Priority Icons
export const priorityUrgentIconProps = makeIconProps("plannerPriorityUrgent");
export const priorityUrgentSmallIconProps = makeIconProps("plannerPriorityUrgentSmall");
export const priorityImportantIconProps = makeIconProps("plannerPriorityImportant");
export const priorityImportantSmallIconProps = makeIconProps("plannerPriorityImportantSmall");
export const priorityMediumIconProps = makeIconProps("plannerPriorityMedium");
export const priorityLowIconProps = makeIconProps("plannerPriorityLow");
export const priorityLowSmallIconProps = makeIconProps("plannerPriorityLowSmall");
export const priorityUrgentNoFillIconProps = makeIconProps("plannerPriorityUrgentNoFill");
export const priorityImportantNoFillIconProps = makeIconProps("plannerPriorityImportantNoFill");
export const priorityMediumNoFillIconProps = makeIconProps("plannerPriorityMediumNoFill");
export const attachSmallIconProps = makeIconProps("plannerAttachSmall");
export const calendarSmallIconProps = makeIconProps("plannerCalendarSmall");
export const chatSmallIconProps = makeIconProps("plannerChatSmall");
export const checklistSmallIconProps = makeIconProps("plannerChecklistSmall");
export const appsSmallIconProps = makeIconProps("plannerAppsSmall");
// Due Date Icons
export const calendarDueDateLateProps = makeIconProps("plannerDueDateLate");
export const calendarDueDateTodayProps = makeIconProps("plannerDueDateToday");
export const calendarDueDateTomorrowProps = makeIconProps("plannerDueDateTomorrow");
export const calendarDueDateWeekProps = makeIconProps("plannerDueDateWeek");
export const calendarDueDateNoDateProps = makeIconProps("plannerDueDateNoDate");
// File icons
export const wordLogoIconProps = makeIconProps("plannerWordLogo");
export const excelLogoIconProps = makeIconProps("plannerExcelLogo");
export const oneNoteLogoIconProps = makeIconProps("plannerOneNoteLogo");
export const outlookLogoIconProps = makeIconProps("plannerOutlookLogo");
export const powerPointLogoIconProps = makeIconProps("plannerPowerPointLogo");
export const projectLogoIconProps = makeIconProps("plannerProjectLogo");
export const visioLogoIconProps = makeIconProps("plannerVisioLogo");
export const formsLogoIconProps = makeIconProps("plannerFormsLogo");
export const formsLogoFilledIconProps = makeIconProps("plannerFormsLogoFilled");
// Fabric icon replacement
export const openFolderProps = makeIconProps("plannerOpenFolder");
export const folderProps = makeIconProps("plannerFolder");
export const documentProps = makeIconProps("plannerDocument");
// Uno Portfolio
export const portfolioStatusProps = makeIconProps("portfolioStatusIcon");
export const portfolioFolderProps = makeIconProps("portfolioFolderIcon");
export const portfolioFolderFilledIconProps = makeIconProps("portfolioFolderFilledIcon");
export const portfolioFolderListIconProps = makeIconProps("portfolioFolderListIcon");
// Uno Create Plan
export const timelineIconProps = makeIconProps("timelineIcon");
export const listIconProps = makeIconProps("listIcon");
export const copilotIconProps = makeIconProps("copilotIcon");
export const rocketLogoIconProps = makeIconProps("rocketLogoIcon");
export const rocketLogoFilledIconProps = makeIconProps("rocketLogoFilledIcon");
export const rocketLogoLargeIconProps = makeIconProps("rocketLogoFilledLargeIcon");
export const plannerLogoOutlineIconProps = makeIconProps("plannerLogoOutlineIcon");
export const plannerLogoFilledIconProps = makeIconProps("plannerLogoFilledIcon");
export const plannerLogoFilledLargeIconProps = makeIconProps("plannerLogoFilledLargeIcon");
export const projectManagerIconProps = makeIconProps("projectManagerIcon");
// Project Home Icons
export const addCircleIconProps = makeIconProps("addCircleIcon");
export const addCircleSmallIconProps = makeIconProps("addCircleIconSmall");
export const loopIconProps = makeIconProps("loopIcon");
export const globeIconProps = makeIconProps("globeIcon");
// AI task icons
export const circleSparkleIconProps = makeIconProps("plannerCircleSparkle");
export const sparkleIconProps = makeIconProps("plannerSparkle");
export const sparkleRegularIconProps = makeIconProps("plannerSparkleRegular");
export const sparkleFilledIconProps = makeIconProps("plannerSparkleFilled");
//Status Report Icons
export const shareIconProps = makeIconProps("shareIcon");
export const sharepointLogoIconProps = makeIconProps("sharepointIcon");
export const sharepointRegularIconProps = makeIconProps("sharepointRegularIcon");
export const sharepointRegularDarkIconProps = makeIconProps("sharepointRegularDarkIcon");
export const sharepointRegularHighContrastIconProps = makeIconProps("sharepointRegularHighContrastIcon");
